/* Publish by EComposer at 2026-10-19 14:55:15*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vkvt63klqq"]=  window.__ectimmers["ecom-vkvt63klqq"] || {};
if(this.isLive)
                {
                    let $el = this.$el,
                    dom = $el.querySelector('.jdgm-preview-badge');
                    if(dom)
                    {
                        dom.addEventListener('click', function(){
                            let widget = document.querySelector('#judgeme_product_reviews');
                            if(widget)
                            {
                                let tab_content = widget.closest('.core__group--item');
                                if(tab_content)
                                {
                                    let dataId = tab_content.getAttribute('data-id');
                                    let nav = document.querySelector('[data-target-id="#'+dataId+'"]') ;
                                    if(nav)
                                    {
                                        nav.click();
                                        tab_content.scrollIntoView({behavior: 'smooth'});
                                    }
                                }
                            }
                        });
                    }
                }

                    });
                    
                        document.querySelectorAll('.ecom-vkvt63klqq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vkvt63klqq', settings: {},isLive: true});
                        });
                    

                })();
            